import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectorRef, Input, Output, EventEmitter } from '@angular/core';
import { AlertHttpService } from '../../../../../app/core/alerts';
import { ActivatedRoute } from '@angular/router';
import { MachineRouteService } from '../machine-route.service';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { OiDialogsComponent } from './oi-dialogs/oi-dialogs.component';
import { MixpanelService } from '../../../../services/mixpanel.service'; // Import MixpanelService

export interface OpenIssue {
	msg: string;
	time_stamp: string;
	code: string;
}

@Component({
  selector: 'kt-open-issues',
  templateUrl: './open-issues.component.html',
  styleUrls: ['./open-issues.component.css']
})
export class OpenIssuesComponent implements OnInit, AfterViewInit {

	logCodes;
	openIssues;

	displayedColumns: string[] = ['time_stamp', 'log_msg', 'clear'];

	dataSource = new MatTableDataSource<any>();

	@Input() showFilter: boolean;

	@Input() showType: string;

	@Input() title: string;

	@Output() issueCntEvent = new EventEmitter<any>();

	loading = false;

	empty = false;

	wrnCnt = 0;
	errCnt = 0;

	selectedMachine: any;

	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

	@ViewChild(MatSort, {static: false}) sort: MatSort;

	constructor(
		private _snackBar: MatSnackBar,
		private http: AlertHttpService,
		private cd: ChangeDetectorRef,
		public dialog: MatDialog,
		private mixpanel: MixpanelService,
		private route: ActivatedRoute,
		private machineRouteService: MachineRouteService
	) { }

	ngOnInit() {
		this.selectedMachine = this.machineRouteService.getMachine(this.route);
		if (!this.selectedMachine) return;
		this.getOpenIssues();

		this.mixpanel.track(this.mixpanel.PAGE_VIEW, {
			machineId: this.selectedMachine.machine_id,
			machineName: this.selectedMachine.machine_name,
			machineSerialNo: this.selectedMachine.serial_no
		});
	}

	ngAfterViewInit() {
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;
	}

	applyFilter(filterValue: string) {
		this.dataSource.filter = filterValue.trim().toLowerCase();
	}

	getLogCodes() {
	}

	clear(issue) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.data = issue;
		const dialogRef = this.dialog.open(OiDialogsComponent, dialogConfig);
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			} else {
				if (res.success) {
					this.http.clearOI(res.clearObj)
					.subscribe(result => {
						this.showSnackBar('Successfully submitted the request. It may take a few mins to clear.', 0);
					}, err => {
						console.log(err);
						this.showSnackBar(err.msg || 'Unable to process', 0);
					});
				}
			}
		});
	  }

	getOpenIssues() {
		this.loading = true;
		this.http.getOpenIssues(this.selectedMachine.machine_id)
		.subscribe(issues => {
			this.loading = false;
			this.openIssues = issues;
			this.updateDataSource();
		});
	}

	updateDataSource() {
		this.dataSource.data = this.openIssues;
		this.cd.detectChanges();
	}

	showSnackBar(message: string, duration: number) {
		let snackRef = this._snackBar.open(message, 'close');
		if (duration > 0) {
			setTimeout(() => {
				this._snackBar.dismiss();
			}, duration);
		}

		snackRef.onAction().subscribe(() => {
			this._snackBar.dismiss();
		});
	}

}
